import { Box, CircularProgress, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/**
 * PageLoader - 페이지 레벨 로딩 표시 컴포넌트
 * React.lazy와 Suspense의 fallback으로 사용
 *
 * @param {string} message - 로딩 메시지 (기본값: '페이지 로딩 중...')
 */
function PageLoader({ message = '페이지 로딩 중...' }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        gap: 2,
      }}
    >
      <CircularProgress
        size={40}
        sx={{ color: theme.palette.primary.main }}
      />
      <Typography
        variant="body2"
        color="text.secondary"
      >
        {message}
      </Typography>
    </Box>
  );
}

export default PageLoader;
